import axios from 'axios';
import { API } from '@/lib/api';

const VISITOR_KEY = 'cfsc_visitor_id';

function getVisitorId() {
  if (typeof window === 'undefined') return 'ssr';
  let vid = localStorage.getItem(VISITOR_KEY);
  if (!vid) {
    vid = `v_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
    localStorage.setItem(VISITOR_KEY, vid);
  }
  return vid;
}

/**
 * Fire-and-forget conversion event tracker.
 * Examples:
 *   trackEvent('cta_essai_click', { location: 'hero' });
 *   trackEvent('reservation_click', { source: 'nav' });
 *   trackEvent('contact_form_submit', { form: 'quick' });
 */
export function trackEvent(name, metadata = {}) {
  try {
    if (typeof window === 'undefined') return;
    if (window.location.pathname.startsWith('/admin')) return;
    axios
      .post(`${API}/analytics/event`, {
        name,
        path: window.location.pathname,
        visitor_id: getVisitorId(),
        metadata,
      })
      .catch(() => {});
  } catch {
    /* never fail the UI for analytics */
  }
}

export const getAnalyticsVisitorId = getVisitorId;
